/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { ResourceData } from './ResourceData.types.tsx';

const RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

export const servicedeskAtlassianAnalyticsResource: RouteResource<ResourceData> =
	createResource<ResourceData>({
		type: RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS,
		getKey: () => 'atlassian analytics',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-atlassian-analytics", jiraSpaEntry: "async-resource-servicedesk-atlassian-analytics" */ './fetchAVPPermission.tsx'
			),
		isBrowserOnly: true,
	});
